import constants from '@/constants'

export const codeToName = function (code, options) {
  if ((!code && code !== 0 && code !== false) || !options) {
    return ''
  }
  const constEnum = constants[options]
    ? Array.isArray(constants[options])
      ? constants[options]
      : Object.values(constants[options])
    : []
  for (const element of constEnum) {
    if (Number(code) === Number(element.code) || code === element.code) {
      return element.name
    }
  }
  return ''
}

export const getName = function (arrPoint, goodsArr) {
  const arrName = []
  if (!arrPoint) {
    return ''
  }
  if (!goodsArr) {
    return ''
  }
  const arr = (arrPoint + '').split(',')
  goodsArr.forEach(item => {
    if (arr.indexOf(item.code.toString()) > -1) {
      arrName.push(item.name)
    }
  })
  return arrName.join(',')
}
export const nameArrFilter = function (str, arr2) {
  const arrName = []
  let goodsArr = []
  if (!str) {
    return '--'
  }
  goodsArr = arr2
  const arr = (str + '').split(',')
  goodsArr.forEach(item => {
    if (arr.indexOf(item.code.toString()) > -1) {
      arrName.push(item.name)
    }
  })
  return arrName.join(',')
}
export const nameArrConstantFilter = function (str, arr2) {
  const arrName = []
  let goodsArr = []
  if (!str) {
    return '--'
  }
  if (!arr2.length) {
    return '--'
  }
  goodsArr = arr2
  const arr = (str + '').split(',')
  goodsArr.forEach(item => {
    if (arr.indexOf(item.mmsCode) > -1) {
      arrName.push(item.mmsName)
    }
  })
  return arrName.join(',')
}
export function formatPrice (value2, currency, decimals) {
  const digitsRE = /(\d{3})(?=\d)/g
  const value = parseFloat(value2)
  if (!isFinite(value) || (!value && value !== 0)) return ''
  currency = currency != null ? currency : ''
  decimals = decimals != null ? decimals : 2
  const stringified = Math.abs(value).toFixed(decimals)
  const _int = decimals
    ? stringified.slice(0, -1 - decimals)
    : stringified
  const i = _int.length % 3
  const head = i > 0
    ? (_int.slice(0, i) + (_int.length > 3 ? ',' : ''))
    : ''
  const _float = decimals
    ? stringified.slice(-1 - decimals)
    : ''
  const sign = value < 0 ? '-' : ''
  return sign + currency + head +
        _int.slice(i).replace(digitsRE, '$1,') +
        _float
}
export function currencySmbol (cuSy) {
  if (cuSy === '1') {
    return '￥'
  }
  return '$'
}
